import { Link } from 'react-router-dom';
import s from './TourCard.module.scss';
import StarRating from '../../components/StarRating/StarRating';
import LazyLoad from 'react-lazyload';

const TourCard = ({ items }) => {
    const formatPrice = (price) =>
        new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'AUD'
        }).format(price || 0);
  if (!items) return null;

  return (
    <div className={s.root}>
      <div className={s.scrollContainer}>
        {items && items.map((item, index) => {
          const tourId =  item.tour_id || item.tourId;
          const rezdyId =  item.rezdy_id || item.rezdyId;
          const image = item.images?.[0] ?? item.image1;
          const title = item.title;
          const rating = item.rating ?? 0;
          const reviewCount = item.reviewCount ?? item.review_count ?? 0;
          const tags = item.tags ?? [];
          const details = item.details ?? '';

          const salePrice = Math.floor(item.salePrice ?? item.sale_price ?? 0);
          const regularPrice = Math.floor(item.regularPrice ?? item.regular_price ?? 0);
          const discountRate = regularPrice > 0 ? Math.round(((regularPrice - salePrice) / regularPrice) * 100) : 0;

          return (
            <div key={index} className={s.card}>
              <div className={s.imageWrapper}>
                <Link to={`/tours/${tourId}`}>
                  <LazyLoad height={200} offset={100} once>
                    <img src={image} alt={title} className={s.image} />
                  </LazyLoad>
                </Link>
              </div>

              <div className={s.detailsContainer}>
                <Link to={`/tours/${tourId}`}>
                  <h3 className={s.title}>{title}</h3>
                </Link>

                <div className={s.rating}>
                  <StarRating score={rating} />
                  <p className={s.rate}>{rating}</p>
                  <p className={s.count}>({reviewCount})</p>
                </div>

                <Link
                  to={`/review/${tourId}`}
                  className={s.ratingLink}
                  state={{
                    breadcrumbItems: [
                      { name: 'ホーム', link: '/' },
                      { name: `${title}の口コミ`, link: '' }
                    ]
                  }}
                />

                <div className={s.tags}>
                  {tags.map((tag, tagIndex) => (
                    <span key={tagIndex} className={s.tag}>
                      {tag.name ?? tag}
                    </span>
                  ))}
                </div>

                <p className={s.details}>{details}</p>
                <div className={s.spacer}></div>

                <div className={s.prices}>
                    {discountRate>0?   <p className={s.salePrice}>{formatPrice(salePrice)}</p>:<p className={s.salePrice}>{formatPrice(regularPrice)}</p>}
                    {discountRate>0? <p className={s.regularPrice}>{formatPrice(regularPrice)}</p>:""}
                    {discountRate>0?<div className={s.label}>{discountRate}%</div>:""}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TourCard;
